import loadingImg from "../assets/images/loader.svg";

const Button = ({
  title,
  type,
  isLoading,
  onClick,
  disabled,
  additonalClasses
}) => {
  return (
    <button
      type={type || "button"}
      className={
        "inline-flex w-full h-[50px] items-center justify-center rounded-[6px] disabled:opacity-50 border border-transparent bg-[#08792A] px-6 py-3 text-base font-bold uppercase text-white shadow-sm hover:opacity-95 tracking-[0.25px] focus:outline-none " +
        (additonalClasses ? additonalClasses : "")
      }
      disabled={isLoading || disabled}
      onClick={onClick}
    >
      {isLoading ? (
        <img src={loadingImg} alt="" width={40} height={40} />
      ) : (
        title
      )}
    </button>
  );
};

export default Button;
